import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, useIonModal, IonButtons, IonButton } from '@ionic/react';
import { useState, useEffect } from 'react';
import { addOutline, chevronBack } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { addUserListener } from '../firebase/users';
import UserEditor from './UserEditor';

const UsersPage: React.FC = () => {
  const history = useHistory();
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});

  useEffect(() => {
    addUserListener((list: any) => {
      setUsers(list);
    });
  }, []);

  const [presentEditor, dismissEditor] = useIonModal(UserEditor, {
    user: user,
    onDismiss: () => dismissEditor()
  });

  function openEditor(e: any = null) {
    if (e !== null) {
      setUser(e);
    } else {
      setUser({})
    }

    presentEditor();
  }

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack}/>
            </IonButton>
          </IonButtons>
          <IonTitle>Użytkownicy</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
       

        {users.map((u: any) => (
          u.enabled?
          <IonItem onClick={(e) => { openEditor(u) }} key={u.id} >
            <IonLabel>{u.surname+" "+u.name+ " ("+u.email+")"}</IonLabel>
          </IonItem>
          :""
        ))}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { openEditor() }}>
            <IonIcon icon={addOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default UsersPage;



